import React from "react";

export default function RefundPolicy() {
  return (
    <>
      {/* Inline styles for Refund Policy page */}
      <style>{`
        body {
          background-image: url('/F.jpg');
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          font-family: 'Poppins', sans-serif;
          margin: 0;
        }

        .terms-main-container {
          margin: 2rem auto;
          padding: 2rem;
          max-width: 800px;
          background-color: rgba(255, 255, 255, 0.164);
          box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.363);
          backdrop-filter: blur(30px);
          border: 2px solid rgba(255, 255, 255, 0.24);
          border-radius: 20px;
        }
        .terms-header {
          text-align: center;
          margin-bottom: 1rem;
        }
        .terms-header img {
          display: block;
          margin: 0 auto 1rem;
          width: 100px;
        }
        .terms-header h1 {
          font-size: 2rem;
          color: rgb(15, 133, 202);
          margin-bottom: 0.5rem;
        }
        .terms-header hr {
          border: none;
          border-top: 2px solid rgba(15, 133, 202, 0.5);
          margin: 0 auto;
          width: 50%;
        }
        .first-block {
          margin-top: 2rem;
        }
        .terms-title {
          font-size: 1.5rem;
          color: rgb(15, 133, 202);
          margin-bottom: 0.5rem;
        }
        .terms-info {
          color: white;
          font-size: 1rem;
          line-height: 1.5;
          margin-bottom: 1rem;
        }
        .term-list {
          margin-left: 1.5rem;
          color: white;
          font-size: 0.9rem;
          list-style: disc;
        }
        .ending-terms {
          color: rgb(216, 225, 255);
          text-align: center;
          margin-top: 2rem;
          font-style: italic;
        }
      `}</style>

      <div className="terms-main-container">
        {/* Company Logo */}
        <img src="/wayuvega.png" alt="Wayuvega Logo" />

        <section className="terms-header">
          <h1>Refund Policy</h1>
          <hr />
        </section>

        <section className="terms-body">
          <div className="first-block">
            <p className="terms-title">&bull; Overview</p>
            <p className="terms-info">
              This document sets forth the refund policy for amounts paid into
              the Wayuvega Wallet via any supported payment channel. The wallet
              is used to access and pay for Wayuvega’s logistics and related
              services.
              <br />
              <br />
              Wayuvega.com (OR Wayuvega.in) is referred to as "Wayuvega"
              throughout this policy.
            </p>
          </div>

          <div className="first-block">
            <p className="terms-title">&bull; Refund Eligibility</p>
            <p className="terms-info">
              If a customer wishes to request a refund of the unused and
              undisputed balance in their Wayuvega Wallet, they must submit a
              formal request along with the required supporting documents.
              <br />
              <br />
              Refund requests are subject to verification and approval by
              Wayuvega’s Finance and Operations teams. Only after proper
              validation will eligible funds be returned via bank transfer.
              <br />
              <br />
              <strong>Please note:</strong> Refunds apply only to unused wallet
              balances. Amounts that have already been consumed for services
              rendered are not eligible for a refund.
            </p>
          </div>

          <div className="first-block">
            <p className="terms-title">&bull; Refund Process</p>
            <p className="terms-info">
              <strong>Submitting a Request</strong>
              <br />
              To initiate a refund, the customer must send a written request to
              both the Wayuvega Support and Finance teams, along with:
              <div className="term-list">
                &rarr; &emsp; Proof of identity (valid KYC documents). <br />
                &rarr; &emsp; Bank account details and a copy of a cancelled
                cheque. <br />
                &rarr; &emsp; Relevant documentation supporting the refund claim
                (if applicable).
              </div>
              <br />
              <strong>Verification & Reconciliation</strong>
              <br />
              Wayuvega will conduct a full reconciliation of the customer's
              wallet transactions to confirm that the requested refund amount is
              unutilized and free from dispute.
              <br />
              <br />
              <strong>Refund Processing</strong>
              <br />
              Once the validation process is completed, Wayuvega will initiate
              the refund to the customer's designated bank account through NEFT
              or another appropriate banking method.
              <br />
              <br />
              The refund will be processed offline; no refunds will be processed
              via the wallet platform or payment gateway directly.
            </p>
          </div>

          <div className="first-block">
            <p className="terms-title">&bull; Refund Timeline</p>
            <p className="terms-info">
              Upon completion of the verification and reconciliation steps,
              eligible refunds will typically be processed within{" "}
              <strong>7 business days</strong>.
              <br />
              <br />
              Please be aware that the time it takes for the refunded amount to
              appear in your bank account may vary depending on your bank’s
              internal processing times.
            </p>
          </div>

          <div className="first-block">
            <p className="terms-title">&bull; Handling Disputes</p>
            <p className="terms-info">
              If there is any disagreement regarding transactions or the refund
              process, the customer should contact Wayuvega Support in the first
              instance.
              <br />
              <br />
              Disputes will be handled in accordance with Wayuvega’s internal
              dispute resolution procedures. Additional documentation may be
              requested from the customer to resolve the matter.
            </p>
          </div>

          <div className="first-block">
            <p className="terms-title">&bull; Contact Information</p>
            <p className="terms-info">
              For queries related to this Refund Policy or for assistance with
              initiating a refund request, customers may contact:
              <div className="term-list">
                &rarr; &emsp; Email (Support):{" "}
                <a href="mailto:support@wayuvega.com">
                  support@wayuvega.com
                </a>{" "}
                <br />
                &rarr; &emsp; Email (Finance):{" "}
                <a href="mailto:finance@wayuvega.com">
                  finance@wayuvega.com
                </a>{" "}
                <br />
                &rarr; &emsp; Phone (Support):{" "}
                <a href="tel:+918130228919">+91-8130228919</a>
              </div>
            </p>
          </div>

          <div className="first-block">
            <p className="terms-title">&bull; Changes to this Policy</p>
            <p className="terms-info">
              Wayuvega reserves the right to amend or update this Refund Policy
              at its discretion. Any such changes will be published on the
              Wayuvega website or communicated through other appropriate
              channels.
            </p>
          </div>

          <div className="first-block">
            <p className="terms-title">&bull; Acceptance of Terms</p>
            <p className="terms-info">
              By recharging the Wayuvega Wallet and using Wayuvega’s services,
              customers acknowledge that they have read, understood, and agreed
              to the terms outlined in this Refund Policy.
            </p>
          </div>

          <div className="first-block">
            <p className="terms-title">&bull; Governing Law</p>
            <p className="terms-info">
              This Refund Policy is governed by the laws applicable in the
              jurisdiction in which Wayuvega operates. Any disputes arising from
              this policy shall fall under the exclusive jurisdiction of the
              courts in New Delhi, India.
            </p>
          </div>

          <p className="ending-terms">
            Thank you for choosing Wayuvega! We look forward to serving you.
          </p>
        </section>
      </div>
    </>
  );
}
